import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { makeCustomDecimalNumberMask } from '@app/functions';
import { Locale, TranslatableKey } from '@app/types/translatable.type';
import { TimeOffRequestRules } from '@models/time-off-v3/time-off-request-rules.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-request-rules-update-card',
    templateUrl: './request-rules-update-card.template.html',
    styleUrls: ['./request-rules-update-card.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class RequestRulesUpdateCardComponent implements OnInit {
    @Input() timeOffRequestRule = new TimeOffRequestRules();
    @Input() unitOfTime: TranslatableKey = 'time-off-v3.days';
    @Input() isUnlimited = false;
    @Output() onChange = new EventEmitter<TimeOffRequestRules>();

    isLoading = false;
    waitingPeriodRadioSelection = false;
    negativeBalanceCapSelection = false;

    numberMask = makeCustomDecimalNumberMask(this.translateService.currentLang as Locale);

    constructor(private translateService: TranslateService) {}

    ngOnInit(): void {
        this.waitingPeriodRadioSelection = !!this.timeOffRequestRule.waitingPeriod;
        this.negativeBalanceCapSelection = !!this.timeOffRequestRule.negativeBalanceCap;
    }

    updateWaitingPeriod(): void {
        if (!this.waitingPeriodRadioSelection) {
            this.timeOffRequestRule.waitingPeriod = 0;
        } else {
            this.timeOffRequestRule.waitingPeriod = this.timeOffRequestRule.getOriginalAttribute('waitingPeriod') ?? 0;
        }
        this.onTimeOffRequestChange();
    }

    updateNegativeBalanceCap(): void {
        if (!this.negativeBalanceCapSelection) {
            this.timeOffRequestRule.negativeBalanceCap = 0;
        } else {
            this.timeOffRequestRule.negativeBalanceCap = this.timeOffRequestRule.originalNegativeBalanceCap ?? 0;
        }

        this.onTimeOffRequestChange();
    }

    onTimeOffRequestChange(): void {
        this.onChange.emit(this.timeOffRequestRule);
    }
}
